// i18n area 'auth' — locale tr-TR (task #171, onda 5): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/auth.tr-TR.meta.json.
import type { enUS } from './auth'

export const trTR: typeof enUS = {
  login: {
    welcome: 'Trantor TVirt v6',
    subtitle: 'Accountunuzda oturum açın',
    username: 'Kullanıcı adı',
    usernamePlaceholder: 'Kullanıcı adını girin',
    usernameHint: 'Bir dizin realminde kimlik doğrulamak için kullanıcı@etkialanı kullanın',
    continue: 'Devam et',
    changeUser: 'Siz değil misiniz?',
    password: 'Parola',
    forgotPassword: 'Parolanızı mı unuttunuz?',
    submit: 'Oturum aç',
    otp: 'Tek kullanımlık kod',
    otpSubtitle: 'Kimlik doğrulayıcınızdaki kodu girin',
    otpHint: 'Kimlik doğrulama uygulamasından altı hane ya da kurtarma kodlarınızdan biri',
    otpSubmit: 'Doğrula',
    invalidCredentials: 'Kullanıcı adı veya parola geçersiz',
    tooManyAttempts: 'Çok fazla deneme — biraz bekleyip yeniden deneyin',
    realmUnavailable: 'Realm şu anda kimlik bilgilerini doğrulayamıyor — kümedeki store erişilemez durumda. Yerel bir kullanıcı olarak oturum açın (break-glass).',
    genericError: 'Oturum açılamadı — TVirt arka ucu erişilebilir mi?'
  },
  user: {
    logout: 'Oturumu kapat',
    password: {
      menu: 'Parolayı değiştir',
      title: 'Parolanızı değiştirin',
      current: 'Mevcut parola',
      new: 'Yeni parola',
      confirm: 'Yeni parolayı onayla',
      mismatch: 'Parolalar eşleşmiyor',
      error: 'Parola değiştirilemedi',
      forcedTitle: 'Devam etmek için parolanızı değiştirin',
      forcedHint: 'Bu parolayı bir yönetici ayarladı; girmeden önce değiştirilmesi gerekir.',
      forcedSubmit: 'Değiştir ve gir'
    },
    mfa: {
      title: 'İki faktörlü kimlik doğrulama',
      subtitle: 'Her oturum açışta istenen ikinci bir faktör',
      loadError: 'İkinci faktör durumu yüklenemedi',
      enrolled: 'Etkin',
      notEnrolled: 'Etkin değil',
      enrolledAt: 'Etkinleştirilme tarihi',
      codesRemaining: 'Kalan kurtarma kodları',
      requiredHint: 'Bir yönetici bu accountta ikinci faktörü zorunlu kılıyor: şimdi yapılandırın — bunu yapana kadar oturum açabilirsiniz ama başka pek bir şey yapamazsınız.',
      enroll: 'Yapılandır',
      enrollTitle: 'İki faktörlü kimlik doğrulamayı yapılandır',
      enrollHint: 'Bu kodu kimlik doğrulama uygulamasıyla tarayın, ardından onaylamak için uygulamanın gösterdiği kodu yazın.',
      secretHint: 'Tarayamıyor musunuz? Bunun yerine bu gizli değeri uygulamaya yazın:',
      code: 'Uygulamadaki kod',
      confirm: 'Onayla',
      startError: 'Yapılandırma başlatılamadı',
      confirmError: 'Yapılandırma onaylanamadı',
      codesTitle: 'Kurtarma kodlarınız',
      codesWarning: 'Bu kodlar yalnızca bir kez gösterilir. Şimdi kaydedin: kimlik doğrulayıcınız kullanılamadığında her biri oturum açmanızı sağlar ve her biri yalnızca bir kez geçerlidir.',
      codesAck: 'Kurtarma kodlarımı kaydettim',
      codesDone: 'Bitti',
      copy: 'Kopyala',
      copied: 'Kopyalandı',
      download: 'İndir',
      regenerate: 'Yeni kurtarma kodları',
      regenerateTitle: 'Kurtarma kodlarını yeniden oluştur',
      regenerateHint: 'Yeni set oluşturulduğu anda şimdiye kadar verilmiş tüm kodlar çalışmayı durdurur.',
      regenerateConfirm: 'Yeniden oluştur',
      regenerateError: 'Kurtarma kodları yeniden oluşturulamadı',
      remove: 'Kaldır',
      removeTitle: 'İkinci faktörü kaldır',
      removeConfirm: 'Kaldır',
      removeHint: 'Account yalnızca parolaya döner. İkinci faktörü istediğiniz zaman yeniden yapılandırabilirsiniz.',
      removeRequiredHint:
        'Bir yönetici bu accountta ikinci faktörü zorunlu kılıyor, bu yüzden sunucu kaldırma isteğini reddedecek — önce zorunluluğu kaldırmalarını isteyin.',
      removeError: 'İkinci faktör kaldırılamadı'
    },
    profile: {
      menu: 'Profilime git',
      sessions: 'Etkin oturumlar',
      sessionsHint: 'Bu düğümdeki açık oturumlarınız',
      sessionsEmpty: 'Etkin oturum yok',
      sessionCreated: 'Oturum açıldı',
      sessionExpires: 'Süre sonu',
      revoke: 'Oturumu geçersiz kıl',
      revokeError: 'Oturum geçersiz kılınamadı',
      loadError: 'Oturumlar yüklenemedi'
    }
  }
}
